import { FC } from 'react';
import ArticleCard from './ArticleCard';
import { Article } from '../../pages/learn/articles/[slug]';

interface Props {
  articles: Array<Article>;
}

const ArticlePreviewsSmall: FC<Props> = ({ articles }) => {
  return (
    <>
      {articles.map((article, index) => {
        return index < 3 ? (
          <div key={article.slug} className='h-56 mb-6'>
            <ArticleCard article={article} />
          </div>
        ) : null;
      })}
    </>
  );
};

export default ArticlePreviewsSmall;
